import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getEditCalender, getSubjectEnrollmentIds } from '../../../redux/features/CRDslice';
import { useSelector } from 'react-redux';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { Autocomplete, Button, Stack, TextField, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import EditPopup from './EditPopup';
import AttendanceDelete from './AttendanceDelete';

export default function CalendarEdit() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const leadIdFromQuery = queryParams.get('leadId');
  const subEnrollId = queryParams.get('subEnrollId');
  const sub_name = queryParams.get('sub_name');
  const dispatch = useDispatch();
  const [subId, setSubId] = useState('');

  const [change, setChange] = useState(false);
  const [open, setOpen] = useState(false);

  const { loading, subjectEnrollmentIds, academicEdit } = useSelector((state) => state.crd);
  const [modalContentName, setModalContentName] = useState('');

  useEffect(() => {
    if (subEnrollId && sub_name) {
      setSubId(subEnrollId);
    } else {
      dispatch(getSubjectEnrollmentIds(leadIdFromQuery))
        .unwrap()
        .then(({ data }) => {
          setSubId(data[0]?.subject_enrollment_id ?? '');
        });
    }
  }, []);
  useEffect(() => {
    if (subEnrollId && sub_name) {
      subId && dispatch(getEditCalender(subEnrollId));
    }
    subId && dispatch(getEditCalender(subId));
  }, [subId, change]);

  const tableHead = [
    {
      field: 'sl_no',
      headerName: 'Sl No',
      width: 80,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'session_date',
      headerName: 'Session Date',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'day_name',
      headerName: 'Day',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'from_time',
      headerName: 'From Time',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'to_time',
      headerName: 'To Time',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'isEditable',
      headerName: 'Action',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: ({ value, row }) => {
        return (
          <Tooltip title={row?.sl_no == 1 ? 'Cannot Edit Start Date' : row?.message}>
            <span>
              <Button
                disabled={row?.sl_no == 1 || !Boolean(value)}
                variant="outlined"
                onClick={() => {
                  setModalContentName('Edit');
                  setOpen(row);
                }}
              >
                Edit
              </Button>
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: 'deleteAttendance',
      headerName: 'Delete',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: ({ value, row }) => {
        return (
          <span>
            <Button
              color="error"
              disabled={!Boolean(row?.trainerAttendanceID)}
              variant="outlined"
              onClick={() => {
                setModalContentName('Delete');
                setOpen(row);
              }}
            >
              Delete
            </Button>
          </span>
        );
      },
    },
  ];
  return (
    <GlobalWrapper title={'Calendar Edit'}>
      <Stack gap={3}>
        <GlobalDialog
          // maxWidth={'md'}
          open={Boolean(open)}
          setOpen={setOpen}
          title={modalContentName}
          fullWidth={true}
          content={
            modalContentName == 'Edit' ? (
              <EditPopup
                lastSessionDate={academicEdit[academicEdit?.length - 1]?.session_date}
                row={open}
                loading={loading}
                setChange={setChange}
                setOpen={setOpen}
              />
            ) : (
              <AttendanceDelete
                subject_enrollment_id={subId}
                row={open}
                loading={loading}
                setChange={setChange}
                setOpen={setOpen}
              />
            )
          }
          closeButton={true}
        />
        <Autocomplete
          loading={loading}
          disablePortal
          getOptionLabel={(option) => option?.subject_name || ''}
          isOptionEqualToValue={(option, value) => option.subject_enrollment_id === value.subject_enrollment_id}
          options={
            subEnrollId
              ? [
                  { subject_name: '', subject_enrollment_id: -1 },
                  { subject_name: sub_name, subject_enrollment_id: subEnrollId },
                ]
              : [{ subject_name: '', subject_enrollment_id: -1 }, ...subjectEnrollmentIds]
          }
          value={
            subEnrollId
              ? { subject_name: sub_name, subject_enrollment_id: subEnrollId }
              : subjectEnrollmentIds?.find((e) => e.subject_enrollment_id === subId) || null
          }
          onChange={(_, v) => {
            setSubId(v?.subject_enrollment_id || -1);
          }}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Subject" />}
        />
        <DataGrid columns={tableHead} rows={academicEdit} getRowId={({ sl_no }) => sl_no} autoHeight />
      </Stack>
    </GlobalWrapper>
  );
}
